<template>
    <!-- <div class="d-flex w-100"> -->
    <div class="box-languagelevel">
        <div class="col-12 col-md-5 col-lg-4 d-flex align-items-end clear-pd-lr-in">
            <p class="text-typepoint" v-html="title">{{title}}
            </p>
        </div>
        <div class="col-12 col-md-7 col-lg-8 clear-pd-lr-in">
            <div class="bar-point-number">
                <p v-for="n in 5" :key=n class="bar-number">{{ n }}</p>
            </div>
            <div class="box-point">
                <div class="bar-point-gray"></div>
                <div class="bar-point-red" :style="{ width: offsetLeft + 'px' }"></div>
                <div class="bar-point">
                    <div v-for="n in 5" ref="numbers" class="btn-cicle" :key=n :class="{ active: (n<=value) }"
                        @click="btnClick(n)"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        // computed: {
        //     computedVal() {
        //         return this.$props.val;
        //     },
        //     computedOffset() {
        //         return this.$refs.numbers[this.$props.val - 1].offsetLeft;
        //     }
        // },

        mounted() {
            if (this.$props.disabled == 'yes') {
                if(this.$props.val!=''){
                    this.value = this.$props.val;    
                    this.offsetLeft = this.$refs.numbers[this.$props.val - 1].offsetLeft;
                }
            }
        },
        props: ['title', 'language', 'val', 'disabled'],
        data() {
            return {
                value: 0,
                offsetLeft: 0,
            }
        },
        methods: {

            btnClick: function (value) {
                if (this.$props.disabled == 'no') {
                    this.$emit('update:val', value);
                    this.value = value;
                    this.offsetLeft = this.$refs.numbers[this.value - 1].offsetLeft;
                }
            }
        },
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/career/LanguageLevel.vue